module.exports = __webpack_public_path__ + "static/scale-model-of-riverfront-city-park-in-salem-oregon-546c6aa5e67e5ebbb462a545469f1897.png";